import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getHomeSlider1 } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function Slider1iew() {

  const { id, partnerId } = useParams();

  const [slideone, setSlideone] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSliderData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const response = await getHomeSlider1(id);
      setSlideone(response.data.data[0]);
    } catch (error) {
      showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch slider data. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = ["Slide number", "Slide Image", "Slide Paragraph"];
  const rows = [];

  if (slideone && Object.keys(slideone).length > 0) {
    rows.push(["Slide 1", slideone.image1 ?  <img src={slideone.image1} alt="slider 2" width="250"/> : null, slideone.paragraph1]);
    rows.push(["Slide 2", slideone.image2 ?  <img src={slideone.image2} alt="slider 2" width="250"/> : null, slideone.paragraph2]);
    rows.push(["Slide 3", slideone.image3 ?  <img src={slideone.image3} alt="slider 2" width="250"/> : null, slideone.paragraph3]);
  }

  useEffect(() => {
    fetchSliderData();
  }, [id]);

  return (
    <>
      {isLoading ? <CmsCircularProgress/> : <ContentWrapper>
      <HomeTitle>Slider 1 Section</HomeTitle>
      <CustomTable
          columns={columns}
          rows={rows}
          isLoading={isLoading}
        />
      <ButtonWrapper>
        <Link to={`/${partnerId}/home`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/home/slider1/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} Slider 1 section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper> }
    </>
 
  );
}

const ContentWrapper = styled.div`
  justify-content: center;
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;


const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
